<template>
  <m4-dialog v-bind="dialog" @onSubmitDialog="$refs.survey_dialog_form.submit()" class="survey-dialog">
    <div v-if="dialog.description" v-html="dialog.description" class="survey-dialog__description"></div>
    <m4-survey ref="survey_dialog_form" v-bind="survey"></m4-survey>
    <template v-slot:button>
      <slot name="button"></slot>
    </template>
  </m4-dialog>
</template>
<script>
export default {
  name: "M4SurveyDialog",
  data() {
    return {};
  },
  props: {
    dialog: Object,
    survey: Object
  },
  methods: {}
};
</script>
